// test757
(757 && 0);
